import { ItemType }      from 'Models/UI/ItemType';
import { TS_AddonBus } from '../TravelSeller/Models/TS_AddonBus';

export class AddonBus extends TS_AddonBus {
    type = ItemType.ARRIVAL_BY_BUS;
}